var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.791,
    height: 35.306,
    viewBox: "0 0 36.791 35.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6570719_class_education_learning_lecture_room_icon_1_",
    "data-name": "6570719_class_education_learning_lecture_room_icon (1)",
    transform: "translate(-22.39 -32.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M259.988,353.168a2.855,2.855,0,1,0-3.277,0,5.018,5.018,0,0,0-2.954,2.76,5.018,5.018,0,0,0-2.957-2.76,2.855,2.855,0,1,0-3.277,0,5,5,0,0,0-3.353,4.714.4.4,0,0,0,.8,0,4.194,4.194,0,1,1,8.389,0,.4.4,0,1,0,.8,0,4.194,4.194,0,1,1,8.389,0,.4.4,0,1,0,.8,0A5,5,0,0,0,259.988,353.168Zm-12.882-2.335a2.057,2.057,0,1,1,2.058,2.057A2.057,2.057,0,0,1,247.106,350.834Zm9.186,0a2.057,2.057,0,1,1,2.057,2.057,2.057,2.057,0,0,1-2.057-2.057Z",
    transform: "translate(-204.308 -291.123)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M247.24,102.829c0-.22-.512-.4-1.144-.4H234.484c-.632,0-1.144.178-1.144.4s.512.4,1.144.4H246.1C246.728,103.227,247.24,103.049,247.24,102.829Z",
    transform: "translate(-194.325 -64.769)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M246.315,137.6c0-.22-.591-.4-1.32-.4H234.66c-.729,0-1.32.178-1.32.4s.591.4,1.32.4H245C245.724,138,246.315,137.819,246.315,137.6Z",
    transform: "translate(-194.325 -96.821)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M233.739,172a.4.4,0,0,0,0,.8h2.428a.4.4,0,0,0,0-.8Z",
    transform: "translate(-194.325 -128.901)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M78.351,129.99a1.723,1.723,0,0,0-2.1-2.73L72.7,129.887l-2.345-3.158a6.021,6.021,0,0,0-4.178-2.664,3.78,3.78,0,1,0-4.431-.022,4.455,4.455,0,0,0-3.688,4.377v7.534a1.666,1.666,0,0,0,1.683,1.658,1.641,1.641,0,0,0,.86-.242v7.788a.4.4,0,0,0,.8,0V129.809a.4.4,0,1,0-.8,0v6.144a.873.873,0,1,1-1.746,0v-7.531a3.652,3.652,0,0,1,3.647-3.645h2.378a5.346,5.346,0,0,1,4.834,2.431l2.584,3.478a.4.4,0,0,0,.557.082l3.866-2.865a.923.923,0,0,1,1.29.206.909.909,0,0,1-.16,1.261l-3.892,3.114a2.306,2.306,0,0,1-3.188-.317L68.532,129.5a.4.4,0,0,0-.7.256v15.4a.4.4,0,0,0,.8,0V130.846l1.537,1.83a3.11,3.11,0,0,0,4.3.427Zm-17.356-9a2.983,2.983,0,1,1,2.983,2.983A2.983,2.983,0,0,1,60.995,120.993Z",
    transform: "translate(-32.744 -78.396)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M136.839,356.9a.4.4,0,0,0-.4.4v8.811a.4.4,0,1,0,.8,0V357.3A.4.4,0,0,0,136.839,356.9Z",
    transform: "translate(-104.998 -299.35)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M56.7,53.5H45.148a.4.4,0,0,0,0,.8H57.105a.4.4,0,0,0,.4-.4V32.569a.4.4,0,0,0-.4-.4H22.939a.4.4,0,0,0-.4.4V48.292a.4.4,0,0,0,.8,0V32.967H56.7Z",
    transform: "translate(0)",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassDashboard);
export default __webpack_public_path__ + "static/media/class-dashboard.9d0aab959ba7baa8f3a2e67f4ed33262.svg";
export { ForwardRef as ReactComponent };